import React from 'react';
import { Icon } from 'legacy-packages/ft-cb';
import CircledValueIcon from './CircledValueIcon';
import CalendarIcon from './CalendarIcon';
import PracticeSkillBox from 'chameleon-packages/units/components/PracticeSkillBox';

const SubunitIcon = ({ subunit, size }) => {
  const { iconName, number } = subunit;

  let usingIcon =
    iconName || (typeof number === 'undefined' ? 'Flag' : 'Circle');
  const usingSize = size || 40;
  const commonProps = { width: usingSize, height: usingSize };

  let label;
  let skillColorIndex;
  if (usingIcon.startsWith('Skillbox')) {
    usingIcon = 'Skillbox';
    label = number;
    skillColorIndex = iconName.replace('Skillbox', '');
  }
  switch (usingIcon) {
    case 'Circle':
      return <CircledValueIcon value={number} {...commonProps} />;
    case 'Calendar':
      return <CalendarIcon value={number} {...commonProps} />;
    case 'Flag':
      return <Icon name="subunit_flag" {...commonProps} />;
    case 'Resources':
      return <Icon name="course_level_resources" {...commonProps} />;
    case 'Check':
      return <Icon name="checkedCircle" {...commonProps} />;
    case 'Skillbox':
      return <PracticeSkillBox label={label} colorIndex={skillColorIndex} />;
    default:
      return <CircledValueIcon value={number} {...commonProps} />;
  }
};

export default SubunitIcon;
